export default "__VITE_ASSET__1d3d857a__"